import { Box, Grid, Notification, T } from '@veracity/vui'
import { Fragment } from 'react'

import { BorderedBox } from '@/components'
import {
  BessOperatingIncomeResult,
  IsoBa,
  SystemConfigurations
} from '@/interfaces'

import { useScenarioResultsSummaryTabAdjustableTableConfig } from '../../hooks'

interface Props {
  isoType?: IsoBa
  systemConfiguration?: SystemConfigurations
  summaryResults: BessOperatingIncomeResult[]
}

export const ScenarioResultsSummaryTabAdjustmentTable = ({
  isoType,
  systemConfiguration,
  summaryResults
}: Props) => {
  const { columnNames, rows, header } =
    useScenarioResultsSummaryTabAdjustableTableConfig(
      isoType,
      systemConfiguration,
      summaryResults
    )

  if (!summaryResults.length)
    return (
      <Notification
        status="warning"
        title="Data Unavailable"
        text="Apologies, results are unavailable due to backward incompatibility."
        w="100%"
      />
    )

  return (
    <Box column>
      <Grid gridTemplateColumns={header.gridColumnTemplate}>
        {header.columns?.map((x, index) =>
          !x.label ? (
            <BorderedBox key={index} />
          ) : (
            <BorderedBox
              key={index}
              p={1}
              bg="seaBlue.28"
              color="white"
              justify="center">
              <T>{x.label}</T>
            </BorderedBox>
          )
        )}
      </Grid>
      <Grid gridTemplateColumns={`repeat(${columnNames.length}, 1fr)`}>
        {columnNames.map(label => (
          <BorderedBox
            bg="skyBlue.77"
            justify="center"
            alignItems="center"
            key={label}>
            <T align="center" weight="medium">
              {label}
            </T>
          </BorderedBox>
        ))}

        {rows?.map((items, index) => (
          <Fragment key={index}>
            {items.map((x, colIndex) => (
              <BorderedBox column align="flex-end" px={1} key={colIndex}>
                <T>{x}</T>
              </BorderedBox>
            ))}
          </Fragment>
        ))}
      </Grid>
    </Box>
  )
}
